<template>
    <v-app light>
        <core-nav/>
        <v-content>
            <v-container fluid class="mt-0 pt-0">
                <router-view></router-view>
            </v-container>
        </v-content>

        <v-footer
            class="mt-10"
            app
            light
            padless
            absolute
        >
            <v-card
                flat
                tile
                class="grey lighten-4 text-center"
                width="100%"
            >
                <v-card-text>
                    <v-btn 
                        icon v-for="social in socials" 
                        :key="social.icon" 
                        :href="social.path" 
                        target="_blank"
                        class="font-weight-medium"
                    >
                        <v-icon>{{ social.icon }}</v-icon>
                    </v-btn>
                </v-card-text>
                <v-card-text class="pt-0 align-center"><!-- this is just a footer --></v-card-text>
                <v-card-text class="">
                    &copy; {{ new Date().getFullYear() }} <strong>wiebkewinzer.de</strong>
                    <span v-for="item in misc" :key="item.path">
                        | <router-link :to="item.path">{{ $t('menu.' + item.name) }}</router-link>
                    </span>
                </v-card-text>
            </v-card>
        </v-footer>

    </v-app>
</template>

<script>
import CoreNav from './components/core/Nav';
import router from '@/router.js';

export default {
    name: 'App',

    components: {
        CoreNav,
    },

    data: () => ({
        socials: router.options.socials,
        misc: router.options.routes[1].children.filter(route => route.section === 'footer-nav'),
    })
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import './assets/styles/main.scss';

.page-wrapper {
    margin-left: 20%;
    margin-right: 20%;
}

footer a {
    color: var(--logo-font-color) !important;
    text-decoration: none;
}

</style>
